import { React, useEffect, useState } from "react";
import { Notificar } from "../Notificador";
import { __ConvertirABase64 } from "../../../Utils/Funciones";
import { Documento } from "../../../Contenedores/Comun/Documento";
import ServicioComun from "../../../servicios/Comun";
import { __CargaTiposDocumentosSolicitudesDePadron } from "../../../Utils/FuncionesSolicitudPadron";

export default function DocumentosSolicitud({
  onChangeDocumentos,
  pasarFuncionLimpiarState,
}) {
  const [listaDocumentos, setListaDocumentos] = useState([]);
  const [archivosSeleccionados, setArchivosSeleccionados] = useState([]);

  useEffect(() => {
    CargarListaDocumentos();
  }, []);

  const CargarListaDocumentos = async () => {
    let tiposDocumentos = await __CargaTiposDocumentosSolicitudesDePadron();

    let documentos = [];
    tiposDocumentos.forEach((item) => {
      let documento = new Documento();
      documento.TipoDocumento.Codigo = item.codigo;
      documento.TipoDocumento.Descripcion = item.descripcion;
      documentos.push(documento);
    });

    setListaDocumentos(documentos);
  };

  const handleFileInput = async (e, tipoArchivo) => {
    const archivo = e.target.files[0];
    const archivoBase64 = await __ConvertirABase64(archivo);
    const documento = new Documento();
    documento.TipoDocumento.Codigo = tipoArchivo;
    documento.NombreArchivo = archivo.name;
    documento.ArchivoBase64 = archivoBase64.split(",")[1];

    const resultadoValidacion = await ServicioComun.ValidarSubidaDeDocumento([
      documento,
    ]);

    if (!resultadoValidacion.esValido) {
      Notificar("error", resultadoValidacion.errores);
      return;
    }

    ActualizarArchivosSeleccionados(documento);
    ActualizarDatosTabla(documento);
  };

  const ActualizarArchivosSeleccionados = (documento) => {
    let archivos = [...archivosSeleccionados];
    const index = archivos.findIndex(
      (x) => x.TipoDocumento.Codigo === documento.TipoDocumento.Codigo
    );
    index === -1 ? archivos.push(documento) : (archivos[index] = documento);

    setArchivosSeleccionados(archivos);
    onChangeDocumentos(archivos);
  };

  const ActualizarDatosTabla = (documento) => {
    let documentosTabla = [...listaDocumentos];
    const index = documentosTabla.findIndex(
      (x) => x.TipoDocumento.Codigo === documento.TipoDocumento.Codigo
    );
    documentosTabla[index].NombreArchivo = documento.NombreArchivo;

    setListaDocumentos(documentosTabla);
  };

  const limpiarState = () => {
    CargarListaDocumentos();
    setListaDocumentos([]);
    setArchivosSeleccionados([]);
  };

  pasarFuncionLimpiarState(limpiarState);

  return (
    <div id="Documentos" className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Documentos</h6>
      </div>
      <div className="card-body">
        <table id="tbDocumentos" className="table table-sm">
          <thead className="table-primary">
            <tr>
              <th>Nombre </th>
              <th>Tipo Documento</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {listaDocumentos.map((item, index) => (
              <tr key={index}>
                <td>{item.NombreArchivo}</td>
                <td>{item.TipoDocumento.Descripcion}</td>
                <td className="w-25">
                  <label className="btn btn-light">
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileInput(e, item.TipoDocumento.Codigo)
                      }
                    />
                    <i className="fas fa-upload text-primary mr-2"></i>
                    Subir archivo
                  </label>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
